export function isFallbackImage(imageUrl?: string): boolean {
  return !imageUrl || imageUrl.includes('fallback');
}
